export const restructureToGroupArray = (apiResponse) => {
  console.log({ apiResponse });
  const result = {
    status: 1,
    data: {
      data: [],
      status: "success",
      message: "Converted with separated groups into classments",
    },
  };

  // Check if apiResponse and apiResponse.data exist
  if (!apiResponse || !apiResponse.data) {
    console.error("Invalid API response structure:", apiResponse);
    return result;
  }

  // Use an empty object as fallback if apiResponse.data is null
  const responseData = apiResponse.data || {};

  for (const [groupName, teams] of Object.entries(responseData)) {
    // Check if teams exists and is an array
    if (!teams || !Array.isArray(teams)) {
      console.warn(`Invalid or empty teams data for group ${groupName}`);
      continue; // Skip this iteration
    }

    const classments = teams.map((team) => ({
      position: team.position || 0,
      club_id: team.id,
      picture_url: team?.school?.school_logo || "",
      club_name: team?.school?.school_name || "",
      club_short_name: (team?.school?.school_name || "").split(" ")[0], // basic short name
      play: team.played || 0,
      win: team.won || 0,
      draw: team.drawn || 0,
      lose: team.lost || 0,
      gf: team.goals_for || 0,
      ga: team.goals_against || 0,
      gd: team.goal_difference || 0,
      point: team.points || 0,
      supporter_point: team.supporter_point || 0,
      forms: [], // empty since Sample B doesn't provide this
    }));

    result.data.data.push({
      name: groupName,
      stage_type_id: 1, // assuming 1 = group stage
      classments: classments,
    });
  }

  return result;
};
